export const columnsOptions = [
  { value: -1, key: 'skip', text: 'Skip' },
  { value: 1, key: 0, text: 'Last Name' },
  { value: 2, key: 1, text: 'Middle Name' },
  { value: 3, key: 2, text: 'First Name' },
  { value: 4, key: 3, text: 'DOB (YYYYMMDD)' },
  { value: 5, key: 4, text: 'Student Number' },
  { value: 6, key: 5, text: 'Serving Number' },
  { value: 7, key: 6, text: 'Grade' },
  { value: 8, key: 7, text: 'Teacher' },
  { value: 9, key: 8, text: 'Site' },
  { value: 10, key: 9, text: 'Parent First Name' },
  { value: 11, key: 10, text: 'Parent Last Name' },
  { value: 12, key: 11, text: 'Parent EMail' },
  { value: 13, key: 12, text: 'Parent Phone' },
  { value: 14, key: 13, text: 'Address 1' },
  { value: 15, key: 14, text: 'Address 2' },
  { value: 16, key: 15, text: 'City' },
  { value: 17, key: 16, text: 'State' },
  { value: 18, key: 17, text: 'Zip Code' },
  { value: 19, key: 18, text: 'SSN' },
  { value: 20, key: 19, text: 'Enroll' },
  { value: 21, key: 20, text: 'Enroll Date (YYYYMMDD)' },
  { value: 22, key: 21, text: 'Balance' },
  { value: 23, key: 22, text: 'Meal Status' },
  { value: 24, key: 23, text: 'Language Id' },
  { value: 25, key: 24, text: 'State Id' },
  { value: 26, key: 25, text: 'Homeroom #' },
  { value: 27, key: 26, text: 'Family Id' },
];

export const mealsDataMapped = {
  2: '2 Free Student',
  3: '3 Reduced Student',
  4: '4 Paid Student',
  5: '5 Withdrawn Student',
  6: '6 Teacher',
  7: '7 Adult',
  8: '8 School Food Service Employee',
};

export const mealOptions = [
  { value: '2', text: '2 Free Student' },
  { value: '3', text: '3 Reduced Student' },
  { value: '4', text: '4 Paid Student' },
  { value: '5', text: '5 Withdrawn Student' },
  { value: '6', text: '6 Teacher' },
  { value: '7', text: '7 Adult' },
  { value: '8', text: '8 School Food Service Employee' },
];

export const mealStatuses = [
  { key: 0, text: '4 - Paid Student', value: 4 },
  { key: 1, text: '6 - Teacher', value: 6 },
  { key: 2, text: '7 - Adult', value: 7 },
  { key: 3, text: '8 - Food Service', value: 8 },
  { key: 4, text: '9 - Catering', value: 9 },
];

export const hours = [
  { key: 0, text: '12', value: 0 },
  { key: 1, text: '01', value: 1 },
  { key: 2, text: '02', value: 2 },
  { key: 3, text: '03', value: 3 },
  { key: 4, text: '04', value: 4 },
  { key: 5, text: '05', value: 5 },
  { key: 6, text: '06', value: 6 },
  { key: 7, text: '07', value: 7 },
  { key: 8, text: '08', value: 8 },
  { key: 9, text: '09', value: 9 },
  { key: 10, text: '10', value: 10 },
  { key: 11, text: '11', value: 11 },
];

export const minutes = [
  { key: 0, text: '00', value: 0 },
  { key: 15, text: '15', value: 15 },
  { key: 30, text: '30', value: 30 },
  { key: 45, text: '45', value: 45 },
];

export const AMorPM = [
  { key: 0, text: 'AM', value: 'AM' },
  { key: 1, text: 'PM', value: 'PM' },
];



// WEBPACK FOOTER //
// ./src/pages/importstudents/fixtures.js